import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TipoDestinoCampanha } from '../enum/tipo-destino-campanha.enum';

export function campanhaDestinoValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const tipoDestino = control.get('tipoDestino')?.value as TipoDestinoCampanha | '';

    if (tipoDestino !== TipoDestinoCampanha.Suitability) {
      return null;
    }

    const destinoId = control.get('destinoId')?.value;
    if (typeof destinoId === 'string' && destinoId.trim()) {
      return null;
    }

    return { destinoRequired: true };
  };
}
